import { createFileRoute } from "@tanstack/react-router";
import { RelationshipPage } from "@/routes/followers.$username";

export const Route = createFileRoute("/following/$username")({
  head: ({ params }) => {
    const title = `@${params.username} is following — Xamseen`;
    const description = `The people @${params.username} follows on Xamseen.`;
    return {
      meta: [
        { title: title.slice(0, 60) },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "profile" },
        { name: "twitter:card", content: "summary" },
      ],
    };
  },
  component: FollowingRoute,
});

function FollowingRoute() {
  const { username } = Route.useParams();
  return <RelationshipPage username={username} kind="following" />;
}
